<template>
  <b-container fluid class="py-3">
    <b-row>
      <b-col>
        <!-- {{ items }} -->
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <MasterEmpty v-if="items.length === 0" eheader="Payment Details" econtent="Payment Details"
            eimg="/src/assets/Img/icons/supplier-mapping.svg" :createline="false" />
          <NormalTable v-model:value="items" v-if="items.length != 0" :paginator="true" class="p-datatable-gridlines"
            :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
            :columns="headers" dataKey="ID" :selectionMode="false" :addnewbtn="true">
            <template v-slot:PaymentTermsDescSlot="{ data }">
              {{ data.PaymentTermsDesc === null ? '-' : data.PaymentTermsDesc }}
            </template>

            <template v-slot:AmountSlot="{ data }">
              <div class="label-d-none tablefield mb-0">
                <InputText placeholder="" clearable name="Amount" id="Amount" @keyup="InvoiceAmountOnChange(data)"
                  label="" v-model="data.Amount" :disabled="false" />
              </div>
            </template>

          </NormalTable>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <b-container v-if="!loading && items.length != 0">
    <b-row class="mb-3">
      <b-col lg="3" md="3" sm="6" cols="12">
        <h5>Overall Invoice Amount</h5>
        <p>{{ payment.overallinvoiceamount || 0 }}</p>
      </b-col>
    </b-row>
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col lg="3" md="3" sm="6" cols="12">
          <div class="field mx-2">

            <CustomDropDown label="Payment Method" name="Payment Method" @change="ChangePaymentmethodName"
              :required-icon="true" :items="paymentmethod" v-model="SupplierPaymentMasterData.PaymentMethodId"
              :rules="{ required: true }" />
          </div>
        </b-col>
        <b-col lg="2" md="2" sm="4" cols="6" v-if="SupplierPaymentMasterData.PaymentMethodId == 5">
          <div class="field mx-2">
            <CustomDropDown label="InputType" name="InputType" @change="ChangePaymentmethodName" :required-icon="true"
              :items="InputTypeOptions" v-model="InputType" :rules="{ required: true }" />
          </div>
        </b-col>
        <b-col v-if="SupplierPaymentMasterData.PaymentMethodId != 1 && SupplierPaymentMasterData.PaymentMethodId != 5"
          lg="3" md="3" sm="6" cols="12">
          <div class="field">
            <TextInput type="text" placeholder="" clearable label="Payment Detail" name="Payment Detail"
              v-model="SupplierPaymentMasterData.BankDetails" :rules="{ required: true }" :required-icon="true" />
          </div>
        </b-col>
        <b-col v-if="SupplierPaymentMasterData.PaymentMethodId == 5" lg="2" md="2" sm="4" cols="6">
          <div class="field">
            <div class="input-with-suffix">
              <TextInput type="text" placeholder="" clearable label="value" name="value"
                v-model="SupplierPaymentMasterData.InputTypevalue" :rules="{ required: true }" :required-icon="true"
                @keyup="PercentageOnchange(SupplierPaymentMasterData.InputTypevalue)" />
              <span v-if="InputType == 2" class="input-suffix">%</span>
            </div>
          </div>
        </b-col>
        <b-col lg="3" md="3" sm="6" cols="12">
          <div class="field">
            <TextInput type="text" placeholder="" clearable label="Amount" name="Amount"
              v-model="SupplierPaymentMasterData.PaymentAmount" :rules="{ required: true, decimal: true }"
              :required-icon="true" @keyup="AmountOnchange(SupplierPaymentMasterData.PaymentAmount)" :disabled="true" />
          </div>
        </b-col>

      </b-row>
      <b-row class="field mx-2">
        <b-col v-if="SupplierPaymentMasterData.PaymentMethodId == 5">
          <Button @click="AddFuntion" label="Add" class="ms-2 p-button-info p-button-sm Footer float-end" />
        </b-col>
      </b-row>
      <b-row v-if="TDSFlag">
        <b-col lg="3" md="4" class="ammount_footer">
          <p class="light-txt">
            TDS Amount
          </p>
          <p>
            <span class="pe-1">&#8377;</span>
            {{ SupplierPaymentMasterData.TDSAmount }}
          </p>
        </b-col>
        <b-col>
          <!-- Action icons -->
          <div class="mt-2">
            <i class="pi pi-pencil text-primary me-3" style="cursor: pointer" @click="edittds" title="Edit"></i>
            <i class="pi pi-trash text-danger" style="cursor: pointer" @click="deletetds" title="Delete"></i>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="TAXFlag">
        <b-col lg="3" md="4" class="ammount_footer">
          <p class="light-txt">
            TAX Amount
          </p>
          <p>
            <span class="pe-1">&#8377</span>
            {{ SupplierPaymentMasterData.TAXAmount }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Button type="submit" label="Send to Pay" class="ms-2 p-button-info p-button-sm Footer float-end" />
        </b-col>
      </b-row>

    </b-form>
  </b-container>

  <Dialog v-model:visible="prepaymentsvisible" modal header="Pre Payment" :style="{ width: '70vw' }">
    <PrePaymentTable :datas="supplierdatas" :showprepayadjustment="prepaymentsvisible" />
  </Dialog>

  <Dialog v-model:visible="debitnotesvisible" modal header="Debit Notes" :style="{ width: '70vw' }"
    @after-hide="closedebitnote">
    <DebitNotesTable :datas="supplierdatas" :showdebitnoteadjustment="debitnotesvisible"
      :selectedRows="updateddebitnotedata" @SendDebitNote="DebitNoteShow" />
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <Toast />

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, onMounted, onUnmounted, nextTick } from "vue";
import NormalTable from "../../../../../../components/FormComponents/NormalTable.vue";
import PrePaymentTable from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/ActivePrePaymentTableView.vue";
import DebitNotesTable from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/ActiveDebitNotesTableView.vue";
import { useRouter, useRoute } from "vue-router";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import TextInput from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import SupplierPaymentDetailService from "../../../../../../modules/Inventory/Service/SupplierPaymentDetailService"
import SupplierPaymentMasterService from "../../../../../../modules/Inventory/Service/SupplierPaymentMasterService"
import { useForm } from "vee-validate";
import moment from "moment";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import { useToast } from "primevue/usetoast";
import { DefaultHttpClient } from "@microsoft/signalr";
import { sl } from "date-fns/locale";

export default defineComponent({
  components: {
    NormalTable,
    PrePaymentTable,
    DebitNotesTable,
    SkeletonTableLoader,
    MasterEmpty,
    TextInput,
    CustomDropDown,
    CreateSuccessully
  },
  props: {
    datas: {
      type: Array,
      default: [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    invoicedata: {
      type: Array,
      default: [],
    },
    prepaymentdata: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    //Declaration
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const router = useRouter();
    const prepaymentsvisible = ref(false);
    const successpop = ref(false);
    const debitnotesvisible = ref(false);
    const supplierdatas: any = ref([]);
    const paymentmethod: any = ref([]);
    const InputTypeOptions = ref([
      { name: 'Amount', value: 1 },
      { name: 'Percentage', value: 2 }
    ]);
    let InputType = ref(2)
    let TDSFlag = ref(false)
    let TAXFlag = ref(true)
    let EditInputType = ref()
    const selectedinvoicedata: any = ref(props.invoicedata);
    const updatedprepaymentdata: any = ref(props.prepaymentdata);
    const updateddebitnotedata: any = ref([]);
    let activeTabIndex = ref(props.activeIndex);
    let UserData = ref();
    UserData.value = localStorage.getItem("UsersData");
    UserData.value = JSON.parse(UserData.value);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    let RolesData = ref();
    RolesData.value = localStorage.getItem("RolesData");
    RolesData.value = JSON.parse(RolesData.value);
    const toast = useToast();
    let IsPayShowFunctionExecuting = false
    watch(
      () => props.invoicedata,
      async (newVal: any) => {
        if (IsPayShowFunctionExecuting) return
        debugger
        payment.value.overallinvoiceamount = 0
        let clonedInvoiceData = JSON.parse(JSON.stringify(props.invoicedata));
        selectedinvoicedata.value = [...clonedInvoiceData];
        IsPayShowFunctionExecuting = true

        selectedinvoicedata.value = selectedinvoicedata.value.map((item: any) => {
          item.InvoiceAmount = item.Amount;
          item.Amount = Number((Number(item.Amount || 0) - Number(item.PaidAmount || 0)).toFixed(2));

          // item.DueAmount = Number((Number(item.InvoiceAmount || 0) - Number(item.PaidAmount || 0)).toFixed(2));

          return item;
        });

        items.value = [...selectedinvoicedata.value]
        Duplitcateitems.value = [...selectedinvoicedata.value]
        await IsPayShow();
        IsPayShowFunctionExecuting = false
      },
      { deep: true }
    );

    watch(
      () => props.activeIndex,
      (newVal: any) => {
        debugger
        if (props.activeIndex == 1) {
          if (IsPayShowFunctionExecuting) return
          IsPayShowFunctionExecuting = true
          IsPayShow();
          IsPayShowFunctionExecuting = false
        }
      },
      { deep: true }
    );


    const Inputvalue = ref();
    const items: any = ref([]);
    const Duplitcateitems: any = ref([]);
    const SupplierPaymentMasterData = ref({
      CreatedAt: "2024-09-12T06:41:49.630Z",
      ModifiedAt: "2024-09-12T06:41:49.630Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      EntityId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      PaymentID: 0,
      Code: "",
      SupplierID: 0,
      PaymentAmount: ref(),
      PaymentMethod: "",
      PaymentDate: "",
      PaymentStatus: 0,
      Remarks: "",
      PaymentMethodId: ref(),
      BankDetails: "",
      TotalDebitAmount: 0,
      TotalPrepaymentAmount: 0,
      StoreId: 0,
      EntityOperationId: 0,
      InputTypevalue: '',
      TDSAmount: 0,
      TAXAmount: 0,
    })
    const copySupplierPaymentMasterData = JSON.parse(JSON.stringify(SupplierPaymentMasterData.value));

    const payment = ref({
      overallinvoiceamount: 0.0,
      overalladjustedbalance: 0.0,
      TotalDebitAmount: 0.0,
      TotalPrepaymentAmount: 0.0
    });
    const paymentcalculation = ref({
      GrossAmount: 0.0,
      TDSAmount: 0.0,
      TAXAmount: 0.0,
      NetAmount: 0.0
    });
    const copypayment = JSON.parse(JSON.stringify(payment.value));
    const route = useRoute();

    const SupplierPaymentDetailData = ref({
      CreatedAt: "2024-09-12T06:41:49.630Z",
      ModifiedAt: "2024-09-12T06:41:49.630Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      EntityId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      PaymentID: 0,
      Id: 0,
      PaymentCode: "",
      PrepaymentID: 0,
      PrepaymentCode: "",
      DebitNoteID: "",
      DebitNoteCode: "",
      InvoiceID: 0,
      InvoiceCode: "",
      AppliedAmount: 0,
      TotalAppliedValue: 0,
      DebitNoteAmount: "",
      PrepaymentsAmount: 0,
      Type: 0,
      PaymentMethod: "",
      PaymentDate: "",
      PaymentAmount: 0,
      PaymentStatus: 0,
      DueAmount: 0,
      POId: 0,
      POPaymentTermsId: 0

    })
    const SupplierPaymentSubDetailData = ref({
      Id: 0,
      PaymentID: 0,
      PaymentDetailsID: 0,
      PaymentType: 0,
      PaymentTypeID: 0,
      PaymentTypeCode: "string",
      Amount: 0,
      BalanceAmount: 0,
      CreatedAt: "2024-09-12T06:41:49.630Z",
      ModifiedAt: "2024-09-12T06:41:49.630Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
    })
    const copySupplierPaymentDetailData = JSON.parse(JSON.stringify(SupplierPaymentDetailData.value));

    const loading = ref(false);
    //Payment Adjustment DataTable Fields
    const headers = [
      {
        header: "Invoice Id",
        field: "InvoiceID",
        class: "filterdisplaynone",
      },
      {
        header: "PO Code",
        field: "POCode",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "PaymentTerms",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        slot: "PaymentTermsDescSlot",
        class: "smallwidth",
      },
      {
        header: "Invoice Amount",
        field: "InvoiceAmount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "Paid Amount",
        field: "PaidAmount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "Payable Amount",
        field: "Amount",
        slot: "AmountSlot",
        fieldDisplay: "false",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "Due Amount",
        field: "DueAmount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
    ];

    function showprepayment() {
      prepaymentsvisible.value = true;
    }
    function showdebitnotes() {
      debugger
      if (updateddebitnotedata.value) {
        updateddebitnotedata.value.map((item: any) => {
          item.UsedAmount = 0
          return item;
        });
      }
      debitnotesvisible.value = true;
    }

    async function IsPayShow() {
      debugger
      payment.value.overallinvoiceamount = 0
      SupplierPaymentMasterData.value.TotalDebitAmount = 0
      SupplierPaymentMasterData.value.TotalPrepaymentAmount = 0
      payment.value.overalladjustedbalance = 0
        ;
      if (items.value.length > 0) {
        items.value.forEach(item => {
          payment.value.overallinvoiceamount = Number((Number(payment.value.overallinvoiceamount) + Number(item.DueAmount)).toFixed(2));
          SupplierPaymentMasterData.value.TAXAmount = Number((
            SupplierPaymentMasterData.value.TAXAmount + Number(item.TaxAmount)
          ).toFixed(2));
        });
      }
      SupplierPaymentMasterData.value.PaymentAmount = payment.value.overallinvoiceamount
      paymentcalculation.value.GrossAmount = payment.value.overallinvoiceamount

    }

    async function closedebitnote() {
      debugger
    }
    // async function sendtopay() {
    //   debugger
    //   let paymentAmount = Number(SupplierPaymentMasterData.value.PaymentAmount + SupplierPaymentMasterData.value.TDSAmount);
    //   await items.value.forEach(item => {
    //     if (paymentAmount > 0) {
    //       debugger
    //       if (item.DueAmount <= paymentAmount) {
    //         item.Paystatus = 2; // Fully paid
    //         item.AmountApplied = item.DueAmount
    //         paymentAmount = paymentAmount - Number(item.DueAmount)
    //         item.RemainingAdjacentBalance = 0
    //       }
    //       else if (item.DueAmount > paymentAmount && paymentAmount != 0) {
    //         item.Paystatus = 1; // Partially paid
    //         item.AmountApplied = paymentAmount
    //         item.RemainingAdjacentBalance = item.DueAmount - paymentAmount
    //         paymentAmount = 0; // Partially paid
    //       } else {
    //         item.Paystatus = 0;
    //         item.AmountApplied = 0
    //         item.RemainingAdjacentBalance = item.DueAmount// Unpaid or no payment applied
    //       }
    //     }
    //   });

    // }


    // const totalAmount = items.value.reduce((sum, item) => {
    //   return sum + (Number(item.Amount) || 0);
    // }, 0);

    async function sendtopay() {
      debugger

      await items.value.forEach(item => {
        debugger
        if (item.DueAmount <= item.Amount) {
          item.Paystatus = 2; // Fully paid
        }
        else if (item.DueAmount > item.Amount && item.Amount != 0) {
          item.Paystatus = 1; // Partially paid
        } else {
          item.Paystatus = 0; // Unpaid or no payment applied
        }

        item.AmountApplied = item.Amount;
        item.RemainingAdjacentBalance = item.DueAmount;
      });

    }
    const DebitNoteShow = (data: any) => {
      debugger
      updateddebitnotedata.value = data;
    };
    onMounted(() => {
      LoadPaymentMethod()
      onMounted
    })
    async function LoadPaymentMethod() {
      try {
        let result = await SupplierPaymentDetailService.GetPaymentMethodList();
        paymentmethod.value = result["result"]
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) { }
    }
    const ChangePaymentmethodName = () => {
      const selectedMethod: any = paymentmethod.value.find(
        (method) => method.value == SupplierPaymentMasterData.value.PaymentMethodId
      );
      if (selectedMethod) {
        SupplierPaymentMasterData.value.PaymentMethod = selectedMethod.name;
      }
    };

    // const IsSubmit = handleSubmit(async (values) => {
    //   debugger;
    //   // Check if any line item Amount is missing or invalid
    //   const invalidItem = items.value.find(item => !item.Amount || isNaN(item.Amount) || Number(item.Amount) <= 0);
    //   if (invalidItem) {
    //     toast.add({
    //       severity: "warn",
    //       summary: "Invalid Amount",
    //       detail: "Please enter a valid Amount for all line items.",
    //       life: 3000,
    //     });
    //     return;
    //   }


    //   alert("...rest of your submit logic")

    // });


    const IsSubmit = handleSubmit(async (values) => {
      debugger;


      const invalidItem = items.value.find(item => !item.Amount || isNaN(item.Amount) || Number(item.Amount) <= 0);
      if (invalidItem) {
        toast.add({
          severity: "warn",
          summary: "Invalid Amount",
          detail: "Please enter a valid Amount for all line items.",
          life: 3000,
        });
        return;
      }


      await sendtopay();
      let result: any;
      let msg = "";
      let PaymentId;
      let result1: any;
      let msg1 = "";
      var arr: any = [];

      SupplierPaymentMasterData.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      SupplierPaymentMasterData.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      SupplierPaymentMasterData.value.PaymentDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      SupplierPaymentMasterData.value.DeptRoleId = Number(RolesData.value.DeptRoleMapId);
      SupplierPaymentMasterData.value.BranchId = Number(UserData.value.BranchId);
      SupplierPaymentMasterData.value.HospitalId = Number(UserData.value.HospitalId);
      SupplierPaymentMasterData.value.ModifiedBy = Number(UserData.value.UserId);
      SupplierPaymentMasterData.value.CreatedBy = Number(UserData.value.UserId);
      SupplierPaymentMasterData.value.EntityId = 3089;
      SupplierPaymentMasterData.value.EntityOperationId = 3089001;
      SupplierPaymentMasterData.value.SupplierID = Number(route.query.Id)

      SupplierPaymentMasterData.value.StoreId = Number(route.query.StoreId);
      if (SupplierPaymentMasterData.value.SupplierID != 0) {
        result = await SupplierPaymentMasterService.CreateData(SupplierPaymentMasterData.value);
        console.log(result);
        PaymentId = result["result"];
        msg = result["ErrorInfo"].ErrorCode;
        console.log(result);
        console.log(msg);
        if (PaymentId != 0) {
          for (let i = 0; i < items.value.length; i++) {
            SupplierPaymentDetailData.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            SupplierPaymentDetailData.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            SupplierPaymentDetailData.value.PaymentDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            SupplierPaymentDetailData.value.DeptRoleId = Number(RolesData.value.RoleId);
            SupplierPaymentDetailData.value.BranchId = Number(UserData.value.BranchId);
            SupplierPaymentDetailData.value.HospitalId = Number(UserData.value.HospitalId);
            SupplierPaymentDetailData.value.ModifiedBy = Number(UserData.value.UserId);
            SupplierPaymentDetailData.value.CreatedBy = Number(UserData.value.UserId);
            SupplierPaymentDetailData.value.EntityId = 3089;
            SupplierPaymentDetailData.value.PaymentID = PaymentId; //getfrom above api data
            SupplierPaymentDetailData.value.PrepaymentsAmount = items.value[i]?.Prepayment ?? 0;
            SupplierPaymentDetailData.value.InvoiceID = items.value[i]?.GRNId ?? 0;
            SupplierPaymentDetailData.value.InvoiceCode = items.value[i]?.InvoiceID ?? '';
            SupplierPaymentDetailData.value.DebitNoteID = "";
            SupplierPaymentDetailData.value.DebitNoteCode = "";
            SupplierPaymentDetailData.value.DebitNoteAmount = String(items.value[i]?.DebitNotesApplied ?? '0'); //Add all debit notes
            SupplierPaymentDetailData.value.Type = 0;
            SupplierPaymentDetailData.value.PaymentMethod = SupplierPaymentMasterData.value.PaymentMethodId.toString();  //getfrom above api data
            SupplierPaymentDetailData.value.PaymentDate = SupplierPaymentMasterData.value.PaymentDate;//getfrom above api data
            SupplierPaymentDetailData.value.PaymentAmount = items.value[i]?.AmountApplied; //payment Amount
            SupplierPaymentDetailData.value.PaymentStatus = items.value[i]?.Paystatus;
            SupplierPaymentDetailData.value.DueAmount = items.value[i]?.RemainingAdjacentBalance;
            SupplierPaymentDetailData.value.POId = items.value[i]?.Id
            SupplierPaymentDetailData.value.POPaymentTermsId = items.value[i]?.POPaymentId
            result1 = await SupplierPaymentDetailService.CreateData(SupplierPaymentDetailData.value);
            console.log(result1);
            items.value[i].Id = result1["result"];
            msg1 = result["ErrorInfo"].ErrorCode;
          }
        }
      }
      if (msg == null && msg1 == null) {
        successpop.value = true;
      } else if (msg != null || msg1 != null) {
        alert('error');
      }
    });
    function closetrigger() {
      debugger
      successpop.value = false;
      updateddebitnotedata.value = []
      items.value = []
      IsClear();
      activeTabIndex.value = 2
    }
    //Clear Input Fields
    function IsClear() {
      debugger
      Object.assign(SupplierPaymentMasterData.value, copySupplierPaymentMasterData);
      Object.assign(copypayment, copypayment);
      Object.assign(copySupplierPaymentDetailData, copySupplierPaymentDetailData);
      SupplierPaymentMasterData.value.PaymentAmount = ref()
      SupplierPaymentMasterData.value.PaymentMethodId = ref();
      SupplierPaymentMasterData.value.SupplierID = supplierdatas.value.SupplierId || 0
      payment.value.overallinvoiceamount = 0
      payment.value.overalladjustedbalance = 0,
        payment.value.TotalDebitAmount = 0
      payment.value.TotalPrepaymentAmount = 0
      selectedinvoicedata.value = []
      updatedprepaymentdata.value = []
      items.value = []
      // Reset form validation errors
      resetForm()
      emit("loadactiveindex");
    }
    function AmountOnchange(newAmount) {
      if (newAmount > payment.value.overallinvoiceamount) {
        toast.add({
          severity: "warn",
          summary: "Amount Should Be less Than overallinvoiceamount",
          detail: "",
          life: 3000,
        });
        SupplierPaymentMasterData.value.PaymentAmount = payment.value.overallinvoiceamount
      }
    }
    async function PercentageOnchange(value) {
      debugger
      if (InputType.value == 1) {
        if (value > SupplierPaymentMasterData.value.PaymentAmount) {
          toast.add({
            severity: "warn",
            summary: "Amount Should Be less Than overallinvoiceamount",
            detail: "",
            life: 3000,
          });
          SupplierPaymentMasterData.value.InputTypevalue = '0';
          SupplierPaymentMasterData.value.PaymentAmount = payment.value.overallinvoiceamount
          SupplierPaymentMasterData.value.TDSAmount = 0
        }
        else {
          SupplierPaymentMasterData.value.PaymentAmount = Number(payment.value.overallinvoiceamount) - (Number(value))
          SupplierPaymentMasterData.value.TDSAmount = Number(value)
        }
      }
      else {
        if (value > 100) {
          toast.add({
            severity: "warn",
            summary: "Percentage Should Be less Than 100",
            detail: "",
            life: 3000,
          });
          SupplierPaymentMasterData.value.InputTypevalue = '0';
          SupplierPaymentMasterData.value.TDSAmount = 0
          SupplierPaymentMasterData.value.PaymentAmount = payment.value.overallinvoiceamount;
        }
        else {
          SupplierPaymentMasterData.value.TDSAmount = Number((
            Number(payment.value.overallinvoiceamount) * (Number(value) / 100)
          ).toFixed(2));
          SupplierPaymentMasterData.value.PaymentAmount = Number(payment.value.overallinvoiceamount) - Number(SupplierPaymentMasterData.value.TDSAmount)
        }
      }




    }
    function AddFuntion() {
      debugger
      TDSFlag.value = true;
      Inputvalue.value = SupplierPaymentMasterData.value.InputTypevalue
      EditInputType.value = InputType.value;
      clear()
    }
    function clear() {
      SupplierPaymentMasterData.value.PaymentMethodId = ref()
      InputType.value = 2
      SupplierPaymentMasterData.value.InputTypevalue = ''
      // Reset form validation errors
      resetField('Payment Method')
      resetField('InputType')
      resetField('value')
    }

    function deletetds() {
      TDSFlag.value = false;
      SupplierPaymentMasterData.value.TDSAmount = 0.0;
      SupplierPaymentMasterData.value.PaymentAmount = payment.value.overallinvoiceamount;
      clear()
    }
    function edittds() {
      debugger
      SupplierPaymentMasterData.value.PaymentMethodId = ref(5);
      ChangePaymentmethodName();
      SupplierPaymentMasterData.value.InputTypevalue = Inputvalue.value;
      InputType.value = EditInputType.value;
    }

    function InvoiceAmountOnChange(data) {
      debugger;

      if (data.Amount === '') {
        data.DueAmount = Number((data.InvoiceAmount - (Number(data.Amount || 0) + Number(data.PaidAmount || 0))).toFixed(2));

        const totalAmount = items.value.reduce((sum, item) => {
          return sum + (Number(item.Amount) || 0);
        }, 0);
        SupplierPaymentMasterData.value.PaymentAmount = totalAmount;
        return;
      }

      if (isNaN(data.Amount) || Number(data.Amount) < 0) {
        toast.add({
          severity: "warn",
          summary: "Invalid Amount",
          detail: "Amount must be a number greater than or equal to zero.",
          life: 3000,
        });
        data.Amount = "";
        return;
      }

      let PayableAmount = Number(Number(data.InvoiceAmount || 0) - Number(data.PaidAmount || 0)).toFixed(2);

      if (Number(data.Amount) > Number(PayableAmount)) {
        toast.add({
          severity: "warn",
          summary: "Invalid Amount",
          detail: `Invoice Amount: ${data.InvoiceAmount || 0}, Paid Amount: ${data.PaidAmount || 0}, Due Amount: ${data.DueAmount || 0}, Payable Amount: ${PayableAmount}`,
          life: 3000,
        });
        data.Amount = (Number(data.InvoiceAmount || 0) - Number(data.PaidAmount || 0)).toFixed(2);
        return;
      }

      data.DueAmount = Number((data.InvoiceAmount - (Number(data.Amount || 0) + Number(data.PaidAmount || 0))).toFixed(2));

      const totalAmount = items.value.reduce((sum, item) => {
        return sum + (Number(item.Amount) || 0);
      }, 0);
      SupplierPaymentMasterData.value.PaymentAmount = totalAmount;
    }


    return {
      items,
      loading,
      headers,
      prepaymentsvisible,
      showprepayment,
      showdebitnotes,
      debitnotesvisible,
      activeTabIndex,
      selectedinvoicedata,
      updatedprepaymentdata,
      updateddebitnotedata,
      IsPayShow,
      supplierdatas,
      sendtopay,
      payment,
      DebitNoteShow,
      closedebitnote,
      LoadPaymentMethod,
      paymentmethod,
      SupplierPaymentMasterData,
      ChangePaymentmethodName,
      IsSubmit,
      UserData,
      Entitydata,
      RolesData,
      SupplierPaymentDetailData,
      successpop,
      closetrigger,
      copySupplierPaymentMasterData,
      copypayment,
      copySupplierPaymentDetailData,
      IsClear,
      AmountOnchange,
      PercentageOnchange,
      paymentcalculation,
      InputTypeOptions,
      InputType,
      AddFuntion,
      TDSFlag,
      TAXFlag,
      deletetds,
      edittds,
      Inputvalue,
      InvoiceAmountOnChange
    };
  },
});
</script>

<style lang="scss" scoped>
.input-with-suffix {
  position: relative;
  display: inline-block;
  width: 100%;
}

.input-suffix {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-weight: bold;
  pointer-events: none;
  z-index: 10;
  margin-top: 12px;
}

.input-with-suffix :deep(.p-inputtext) {
  padding-right: 35px !important;
}
</style>
